import { defineStore } from "pinia";
import { watch } from "vue";

export const sympomedStore = defineStore('sympomed', {
    state() {
        return {
            consents: {
                profession: null,
            },
        };
    },

    actions: {
        init() {
            this.consents = JSON.parse(localStorage.getItem('consents')) ?? {};

            watch(this.consents, (state) => {
                localStorage.setItem('consents', JSON.stringify(state))
            }, {
                deep: true,
            })
        },
    },
});